// extracted by mini-css-extract-plugin
export default {"hero":"style_hero__0pFY-"};